export default __webpack_public_path__ + "static/jenie-b9a046058aa27a5bed0132261c5a4ff6.png";